module.exports = __webpack_public_path__ + "img/1_022.3b4aee80.jpg";